import {
  ApolloClient,
  DefaultOptions,
  HttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client'
import { useMemo } from 'react'

import { CONSTANTS } from '@/constants'

const { MODERN_BACKEND_API_URI, LEGACY_BACKEND_API_URI } = CONSTANTS

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'none',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'none',
  },
  mutate: {
    errorPolicy: 'none',
  },
}

let apolloClient: ApolloClient<NormalizedCacheObject> | undefined

const legacyBackendLink = new HttpLink({
  uri: LEGACY_BACKEND_API_URI,
})

const modernBackendLink = new HttpLink({
  uri: MODERN_BACKEND_API_URI,
  credentials: 'include',
})

function createApolloClient() {
  return new ApolloClient({
    ssrMode: typeof window === 'undefined',
    link: HttpLink.split(
      (operation) => operation.getContext().clientName === 'legacy-backend',
      legacyBackendLink,
      modernBackendLink
    ),
    cache: new InMemoryCache(),
    defaultOptions,
  })
}

export function initializeApollo(initialState: any = null) {
  const _apolloClient = apolloClient ?? createApolloClient()

  // If your page has Next.js data fetching methods that use Apollo Client, the initial state
  // get hydrated here
  if (initialState) {
    _apolloClient.cache.restore(initialState)
  }
  // For SSG and SSR always create a new Apollo Client
  if (typeof window === 'undefined') return _apolloClient
  // Create the Apollo Client once in the client
  if (!apolloClient) apolloClient = _apolloClient

  return _apolloClient
}

export function useApollo(initialState: any) {
  const store = useMemo(() => initializeApollo(initialState), [initialState])
  return store
}
